import API_URL from '../config';

export const getOktaStats = async (token) => {
  const response = await fetch(`${API_URL}/okta/stats`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to fetch Okta stats');
  return data;
};

export const getOktaUsers = async (token) => {
  const response = await fetch(`${API_URL}/okta/users`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to fetch Okta users');
  return data;
};

export const getOktaGroups = async (token) => {
  const response = await fetch(`${API_URL}/okta/groups`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to fetch Okta groups');
  return data;
};

export const getOktaApps = async (token) => {
  const response = await fetch(`${API_URL}/okta/apps`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to fetch Okta apps');
  return data;
};